import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@ui/dialog.tsx';
import { useTranslation } from 'react-i18next';
import type { FC } from 'react';
import { CreateBoosterForm } from './create-booster-form.tsx';
import type { BoosterDraftData } from './create-booster-form-schema.ts';

interface CreateBoosterDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onNext: (draft: BoosterDraftData) => void;
  defaultValues?: BoosterDraftData | null;
}

/** Modale étape 1 : informations générales avant la sélection des références. */
export const CreateBoosterDialog: FC<CreateBoosterDialogProps> = ({
  isOpen,
  onOpenChange,
  onNext,
  defaultValues
}) => {
  const { t } = useTranslation();

  // Ferme cette modale et transmet le brouillon validé à l'étape de sélection.
  const handleNext = (draft: BoosterDraftData) => {
    onOpenChange(false);
    onNext(draft);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-2xl overflow-hidden p-0"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <div className="scrollable max-h-[90vh] overflow-y-auto p-14">
          <DialogHeader>
            <DialogTitle className="text-2xl">{t('boosters.create.dialog.title')}</DialogTitle>
            <DialogDescription>{t('boosters.create.dialog.description')}</DialogDescription>
            <p className="text-sm text-muted-foreground">
              {t('boosters.create.dialog.description.2')}
            </p>
            <p className="mt-1 text-sm text-muted-foreground">
              <span className="text-destructive">*</span>
              {t('boosters.create.form.required.fields')}
            </p>
          </DialogHeader>

          <div className="mt-6">
            <CreateBoosterForm onNext={handleNext} defaultValues={defaultValues ?? undefined} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
